import { showModalBasketHappy, showModalBasketHappyTransition } from "@/happyTheme/event/modalBasket/showModalBasketHappy";
import { TimeOutClass } from "@/happyTheme/services/timeout/TimeOutClass";

export function toggleShowModalBasketHappy() {
    const timeOutClass = TimeOutClass.getInstance();
    if (!showModalBasketHappy.value) {
        showModalBasketHappy.value = true
        const timeOutId = setTimeout(() => {
            showModalBasketHappyTransition.value = true
        }, 100)
        timeOutClass.setIdTimeout(timeOutId)
    } else {
        showModalBasketHappyTransition.value = false
        const timeOutId = setTimeout(() => {
            showModalBasketHappy.value = false
        }, 300)
        timeOutClass.setIdTimeout(timeOutId)
    }

    const html = document.documentElement

    if (!html.classList.contains('modal-open')) {
        html.classList.add('modal-open')
    } else {
        html.classList.remove('modal-open')
    }
}